import React from "react";
import { motion } from "framer-motion";
import { AiOutlineWarning } from "react-icons/ai";
import Button from "../Button";

const ErrorModal = ({ message, subMessage, onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.3, ease: "easeOut" }}
        className="bg-white rounded-lg  p-6 w-full max-w-md text-center relative"
      >
        <Button
          onClick={onClose}
          className="absolute top-2 right-3 text-gray-500 text-xl"
        >
          &times;
        </Button>

        {/* Animated Warning Icon */}
        <motion.div
          className="text-6xl text-yellow-500 flex justify-center mb-4"
          animate={{ scale: [1, 1.3, 1], rotate: [0, 5, -5, 0] }}
          transition={{
            repeat: Infinity,
            duration: 1.5,
            ease: "easeInOut",
          }}
        >
          <AiOutlineWarning />
        </motion.div>

        <h2 className="text-xl font-semibold text-gray-800">
          {message || "Oops...! Something went wrong!"}
        </h2>

        <p className="text-sm text-gray-600 mt-2">
          {subMessage || "Please try again later."}
        </p>

        <Button
          text="Dismiss"
          onClick={onClose}
          className="mt-6 bg-blue-700 text-white px-4 py-2 rounded hover:bg-blue-800 transition"
        ></Button>
      </motion.div>
    </div>
  );
};

export default ErrorModal;
